((BoyProductImage, $) => {
  'use strict';

  let $case;
  let $variant;

  const cacheDom = () => {
    $case = $('.js-sleeve-active');
    $variant = $('.js-single-variant');
  };

  const bindUIActions = () => {
    $variant.on('click', function () {
      const $this = $(this);
      const itemType = $this.attr('data-item-type');
      if (itemType.toLowerCase() === 'sleeve') {
        $case.show();
      } else {
        $case.hide();
      }
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  BoyProductImage.init = init;

})(window.BoyProductImage = window.BoyProductImage || {}, jQuery);
